import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-layer',
  templateUrl: './layer.component.html',
  styleUrls: ['./layer.component.css']
})
export class LayerComponent implements OnInit {
  @Input() layers: any = [];
  @Input() previews: any = [];
  @Input() selectedLayerId: any = null;
  @Input() hubList: any = [];
  @Output() changedLayer = new EventEmitter();

  constructor() { }

  ngOnInit(): void { }

  clickLayer(id: any) {
    this.changedLayer.emit({ id: id, type: 'clickLayer' });
  }

  drop(event: any) {
    if (event.previousIndex === event.currentIndex) return;
    moveItemInArray(this.layers, event.previousIndex, event.currentIndex);
    moveItemInArray(this.previews, event.previousIndex, event.currentIndex);
    this.layers.forEach((e, i) => {
      e.index = i;
    });
    this.previews.forEach((e, i) => {
      e.layer['z-index'] = i;
    });
    this.changedLayer.emit({ type: 'drop' });
  }

  textLayerChange(event: any, id: any) {
    this.changedLayer.emit({ id: id, type: 'textLayer', text: event.target.value });
  }

  hiddenToggle(id: any) {
    const index = this.layers.findIndex(x => x.id == id);
    if (index == -1) return;
    return this.previews[index].layer.display;
  }

  hideLayer(id: any) {
    this.changedLayer.emit({ id: id, type: 'hideLayer' });
  }

  isCollection(id: any) {
    const result = this.hubList.find(x => x.layer_id == id);
    return result && result.hasOwnProperty('collection_id') ? true : false;
  }

  getHubStatic(id: any) {
    const result = this.hubList.find(x => x.layer_id == id);
    if (!result) return;
    else if (result.hasOwnProperty('collection_id') && result.hasOwnProperty('collection_static')) return `${result.collection_static}_${result.collection_id}`;
    else if (result.hasOwnProperty('collection_id')) return result.collection_id;
    else return result.static;
  }
}
